export default {
  admin: 'admin',
  customer: 'customer',
};